export default {
  api: 'https://openschool-api.devp.eastedu.ltd/teaching_api',
  file: 'https://gateway.devp.eastedu.ltd/file-service',
  trackApi:
    'https://eastedu-develop.cn-shenzhen.log.aliyuncs.com/logstores/open_school/track?APIVersion=0.6.0',
  userCenter: 'https://passport.eastedu.com/wechat/qrcode',
  // resourceCenter: 'http://192.168.101.59:8006', // 资源补发
  resourceCenterDownload: 'https://orgmember.devp.eastedu.ltd', // 文件加密
  examinationAndAnalysis: 'http://192.168.101.59:5002', // 同考同析
  ebi: 'https://ebi.develop.eastedu.ltd',
  ip: 'https://tool.eastedu.com/ip', // ip与服务器时间
  pingguoApi: 'https://gateway.devp.eastedu.ltd/infrastructure-cache-service',
  userCenterApi: 'https://gateway.devp.eastedu.ltd/user-center-api',
  markupService: 'https://gateway.devp.eastedu.ltd/infrastructure-markup-service',
  gateway: 'https://gateway.devp.eastedu.ltd',
};
